import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { getConsultores, deleteConsultor, getMetricasUsuariosExcel } from "../../../services";
import {LoginAsConsul} from "../../../services/auth.service"
import { Link } from "react-router-dom";
import Add from "../../../icons/add.svg";
import Excel from "../../../icons/excel.svg";
import HeaderBackground from "../../../images/banner_administradores.jpg";
import Lupa from "../../../icons/lupa.svg";
import Delete from "../../../icons/delete.svg";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { Box, Tooltip, Modal, TextField, Button } from "@mui/material";
import { DataTable } from "../../../components";
import FiltrosPersonal from "../../../components/filtros/filtrosPersonal";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { UsuarioContext } from "../../../providers/userContext";
import { useLocation, useNavigate } from 'react-router-dom';
import { Login } from '@mui/icons-material';
import { construirURLParamsFiltros, useRecogerURLParamsFiltros } from "../../../functions/parametrosURL/funcionesParamsURL";

const EMAIL_EXCLUIDO_EXCEL = "ane.nieto@grupolae.net";

const modalCenterStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  zIndex: 1000,
};
const modalPaperStyle = {
  backgroundColor: "#fff",
  border: "2px solid #000",
  boxShadow:
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
  padding: "16px 32px 24px",
};


const Consultores = () => {
  const { t } = useTranslation('common');

  // const location = useLocation();

  // let params = new URLSearchParams(location.search);

  // const pagina = parseInt(params.get("pagina") ) ;
  // const limiteParam = parseInt(params.get("limite") ) ;
  const urlPadre = window.location.pathname;
  const navigate = useNavigate();
  const {filtrosIniciales, filtroOrder} = useRecogerURLParamsFiltros();


  const user = useContext(UsuarioContext)
  const [consultores, setConsultores] = useState([]);
  const [recargar, setRecargar] = useState(true);
  const [loading, setLoading] = useState(true);
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  // const [limite, setLimite] = useState(limiteParam);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });
  const location = useLocation();

  const puedeExportarExcel =
    user?.rol === "ADMIN" &&
    (user?.email || "").toLowerCase() !== EMAIL_EXCLUIDO_EXCEL;

  const [modalExcelOpen, setModalExcelOpen] = useState(false);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [descargando, setDescargando] = useState(false);

  const abrirModalExcel = () => {
    setFechaInicio("");
    setFechaFin("");
    setModalExcelOpen(true);
  };

  const cerrarModalExcel = () => {
    if (descargando) return;
    setModalExcelOpen(false);
  };

  const generarExcel = async () => {
    if (!fechaInicio || !fechaFin) {
      toast.warn(t('excel.selectBothDates'));
      return;
    }
    if (fechaInicio > fechaFin) {
      toast.warn(t('excel.invalidDateRange'));
      return;
    }
    setDescargando(true);
    try {
      const blobData = await getMetricasUsuariosExcel(fechaInicio, fechaFin);
      const blob = new Blob([blobData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `metricas_por_usuario_${fechaInicio}_al_${fechaFin}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setModalExcelOpen(false);
    } catch (error) {
      console.error(error);
      toast.error(t('excel.excelError'));
    } finally {
      setDescargando(false);
    }
  };


  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {

      fetchData();
      localStorage.setItem("hasReloaded", "false"); 
    }
  }, [location]);

 

  const filtrarDatos = (filtros) => {
    setBusqueda({ ...filtros });
    setBusquedaActiva(true);
  };

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  };

  const fetchData = async ({ offset, limit, filtros = busqueda, order,orderBy,} = {}) => {

    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order = order || filtroOrder.orden || 'ASC';

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros,order,orderBy);

    // setLimite(limit)
    const payload = {
      filtros,
      params: {
        page: offset, limit, order,orderBy
      },
    };
    try {
      setLoading(true);
      const response = await getConsultores(payload);
      const { meta, data } = response;

      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const formatData = (data) => {
    return data.map((row, i) => ({
      id: i + 1,
      nombre: row.nombre + " " + row.apellidos,
      nif: row.nif,
      aaff: row.nif,
    }));
  };

  const consultoresRows = [

    {
      id: "nombre",
      numeric: false,
      disablePadding: false,
      label: t('consultants.columns.consultant'),
      noObjeto:true,
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('consultants.columns.nif'),
    },
    {
      id: "aaff",
      numeric: false,
      disablePadding: false,
      label: t('consultants.columns.propertyManagers'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Link to={"/consultores/" + row.nif + "/aaff"}>
          <img
            src={Lupa}
            alt={t('consultants.columns.propertyManagers')}
            className="tableIcon"
          ></img>
        </Link>
      )
    },
    user.rol === 'ADMIN' ?
      {
        id: "eliminar",
        numeric: false,
        disablePadding: false,
        label: t('consultants.columns.delete'),
        noObjeto: true,
        overrideFunc: (data, row) => (
          <img
            src={Delete}
            alt={t('actions.delete')}
            className="tableIcon"
            onClick={() => eliminarConsultor(row)}
          ></img>
        )
      }
      :
      {

        noObjeto:true

      },
      user.rol === 'ADMIN' ?
      {
        id: "login",
        numeric: false,
        disablePadding: false,
        label: "",
        noObjeto: true,
        overrideFunc: (data, row) => (
          <Tooltip title={t('messages.loginAs', { name: row.nombre })} >
            <div className="bigBtn p-2" onClick={() => {LoginAsConsul(row.nif)}}>
              <Login fontSize="small" />
            </div>
          </Tooltip>
        )
      }
      :
      {

        noObjeto:true

      },
  ]

  const eliminarConsultor = (com) => {
    let nombre = com.nombre + " " + com.apellidos;
    Swal.fire({
      title: t('consultants.messages.confirmDelete'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: t('actions.cancel'),
      confirmButtonText: t('messages.yesDelete'),
    })
      .then((result) => {
        if (result.isConfirmed) {
          deleteConsultor(com.nif)
            .then((res) => {

              if (res.message === "CONSULTANT_DELETED") {
                toast.success(t('consultants.messages.deleted'));
                setRecargar(!recargar);
              } else {
                toast.error(t('consultants.messages.deleteError'));
              }
            })
            .catch((e) => {
              toast.error(t('consultants.messages.deleteError'));
              console.log(e);
            });
        }
      })
      .catch((e) => {
        toast.error(t('messages.error'));
        console.log(e);
      });
  };

  return (
    <>
      {/* <div
        className="pageHeader"
        style={{ backgroundImage: `url(${HeaderBackground})` }}
      >
        Consultores
      </div> */}
      <BreadCrumb rutas={[{ path: '/aaff', label: t('consultants.title') }]} style={{ margin: '0 10px' }} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('consultants.title').toUpperCase()}
          </div>
        </div>
      </div>

      <div className="pageContent tableContainer">
        <div className="contentBar">
          {puedeExportarExcel ? (
            <button
              className="bigBtn"
              onClick={abrirModalExcel}
              disabled={descargando}
            >
              {!descargando ? (
                <>
                  <img
                    src={Excel}
                    alt={t('excel.generateList')}
                    width="30px"
                    style={{ marginRight: '10px' }}
                  />
                  <span>{t('excel.generateList')}</span>
                </>
              ) : (
                <>
                  <CircularProgress
                    style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }}
                  />
                  <span>{t('excel.generatingList')}</span>
                </>
              )}
            </button>
          ) : (
            <div></div>
          )}
          {(user.rol === "ADMIN" || user.rol === "CONSUL" || user.rol === "VENT") && (
            <Link to="/consultores/nuevo">
              <div className="contentButton">
                <img src={Add} alt={t('consultants.new')} />
              </div>
            </Link>
          )}
        </div>
        <FiltrosPersonal
          onFilter={filtrarDatos}
          clearFilter={clearFilters}
          filtrosIniciales={busqueda}
        />
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={consultoresRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('consultants.messages.noConsultants')}
              />
            </Box>
          </Box>
        </div>
        {/* <div className="tableWrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                <th style={{ textAlign: "center" }}>Consultor</th>
                <th style={{ textAlign: "center" }}>NIF</th>
                <th style={{ textAlign: "center" }}>Administradores Fincas</th>
                {user.rol === "ADMIN" && 
                  <th style={{ textAlign: "center" }}>Eliminar</th>
                }
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    <CircularProgress style={{ color: "#92004D" }} />{" "}
                  </td>
                </tr>
              ) : (
                <></>
              )}
              {consultores.map((e, i) => {
                return (
                  <tr key={i}>
                    <td style={{ textAlign: "center" }}>{i + 1}</td>
                    <td style={{ textAlign: "center" }}>
                      {e.nombre + " " + e.apellidos}
                    </td>
                    <td style={{ textAlign: "center" }}>{e.nif}</td>
                    <td style={{ textAlign: "center" }}>
                      <Link to={"/consultores/" + e.nif + "/aaff"}>
                        <img
                          src={Lupa}
                          alt="Administradores de Fincas"
                          className="tableIcon"
                        ></img>
                      </Link>
                    </td>
                    {user.rol === "ADMIN" && 
                      <td style={{ textAlign: "center" }}>
                        <img
                          src={Delete}
                          alt="ELIMINAR"
                          className="tableIcon"
                          onClick={() => eliminarConsultor(e)}
                        ></img>
                      </td>
                    }
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div> */}
      </div>

      <Modal
        aria-labelledby="modal-excel-title"
        aria-describedby="modal-excel-description"
        sx={modalCenterStyle}
        open={modalExcelOpen}
        onClose={cerrarModalExcel}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500, style: { zIndex: 999 } }}
        style={{ zIndex: 1000 }}
      >
        <Box sx={modalBoxStyle}>
          <div style={modalPaperStyle}>
            <h2 id="modal-excel-title" style={{ marginBottom: "24px" }}>
              {t('excel.userMetricsModalTitle')}
            </h2>
            <div id="modal-excel-description">
              <form noValidate autoComplete="off">
                <div
                  style={{
                    margin: "8px 0",
                    width: "100%",
                    boxSizing: "border-box",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <TextField
                    variant="standard"
                    type="date"
                    id="fechaInicio"
                    name="fechaInicio"
                    label={t('excel.startDate')}
                    value={fechaInicio}
                    onChange={(e) => setFechaInicio(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                  <TextField
                    variant="standard"
                    type="date"
                    id="fechaFin"
                    name="fechaFin"
                    label={t('excel.endDate')}
                    value={fechaFin}
                    onChange={(e) => setFechaFin(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </div>
                <div
                  style={{
                    margin: "8px 0",
                    width: "100%",
                    boxSizing: "border-box",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridGap: "15px",
                    fontSize: "12px",
                    marginTop: "24px",
                  }}
                >
                  <Button
                    className="btn-Default"
                    variant="contained"
                    onClick={cerrarModalExcel}
                    disabled={descargando}
                    style={{ opacity: descargando ? 0.6 : 1, fontSize: '0.875rem' }}
                  >
                    {t('actions.cancel')}
                  </Button>
                  <Button
                    className="btn-Secondary"
                    variant="contained"
                    color="secondary"
                    onClick={generarExcel}
                    disabled={descargando}
                    style={{ opacity: descargando ? 0.6 : 1, fontSize: '0.875rem' }}
                  >
                    {descargando ? (
                      <CircularProgress style={{ height: 20, width: 20, color: "#fff" }} />
                    ) : (
                      t('excel.generateList')
                    )}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default Consultores;
